<ng-container>
  <div class="download">
    <div class="corner has-border-primary"></div>
    <span class="icon has-text-white">
      <i class="fas fa-lg fa-check"></i>
    </span>
  </div>
</ng-container>
